import { IExpandedTextAdTemplate } from "../../../../interfaces/DynamicCampaigns/IDynamicCampaign";
import DesktopPreview from "../../../AdWords/AdPreview/DesktopPreview";
import ResponsiveAdPreviewFromTemplate from "../../../../hooks/dynamicCampaigns/ResponsiveAdPreviewFromTemplate";

const SmallResponsiveAdPreviewValidation = ({
    ad,
    vehiclesForPreview,
    processedAd
}: {
    ad: IExpandedTextAdTemplate;
    vehiclesForPreview: any;
    processedAd: ResponsiveAdPreviewFromTemplate;
}) => {
    const representativeItems = Object.keys(vehiclesForPreview).map((inventoryKey) => vehiclesForPreview[inventoryKey]);
    const isValid = processedAd.isValid();
    return (
        <div
            className={
                (isValid.valid ? "border border-green-400" : "border-2 border-red-500") +
                " rounded  flex flex-col bg-white"
            }
        >
            <div className={"px-4 py-2"}>{ad.label}</div>
            <div
                className={
                    "h-64 overflow-y-scroll rounded-b flex flex-col border-t " +
                    (isValid.valid ? "border-green-400" : "border-red-500")
                }
            >
                {representativeItems.map((items, index) => (
                    <div key={"rsa_" + index}>
                        <DesktopPreview {...processedAd.render(items)} />
                    </div>
                ))}
            </div>
            {!isValid.valid && (
                <div className={"px-4 py-2 text-red-500 border-t border-red-500"}>{isValid.message}</div>
            )}
        </div>
    );
};

export default SmallResponsiveAdPreviewValidation;
